exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-wrapper[data-v-d7724ef0] {\n  width: 30px;\n  border-radius: 8px;\n  background-color: #e9f1fb;\n  height: 30px;\n  align-self: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.icon-wrapper span[data-v-d7724ef0] {\n  color: #085FCE;\n  fill: #085FCE;\n  margin-top: -4px;\n}\n.search-icon[data-v-d7724ef0] {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-53%);\n}", ""]);

// exports
